import React from "react";
import styles from "./form-input.module.css";

const FormInput = React.forwardRef((props, ref) => {
  const {
    placeholder,
    onChange,
    className,
    style,
    type,
    custom,
    isError,
  } = props;

  const customClassName = custom
    ? className
    : ` rounded w-full px-4 text-sm ${className} ${styles.input}`;

  const errorClassName = isError ? " border-2 border-error-text" : " border";

  const finalClassName = customClassName + errorClassName;

  const isNotErrorStyle = !isError ? { borderColor: "#ddd" } : {}

  const finalStyle = custom ? style : { ...isNotErrorStyle, ...style };

  return (
    <input
      className={finalClassName}
      placeholder={placeholder}
      onChange={onChange}
      style={finalStyle}
      type={type}
      ref={ref}
      {...props}
    />
  );
});

export { FormInput };
